@let blok = block();

<div
    class='s1-footer-recruit__inner-container'>
    @for (child of blok.children; track child._uid) {
        <s1-cms-component [blok]="child"/>
    }
</div>
